<template>
  <div class="help-center">
    <img class="head-banner-bg" src="../../assets/img/head-banner-bg.jpg" />
    <question-category-seller></question-category-seller>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import QuestionCategorySeller from './QuestionCategory/QuestionCategorySeller'

export default {
  name: 'HelpCenterSeller',
  created() {
    native.setTitle({
      title: '客服中心'
    })

    lego.send({
      pagetype: 'ZZUP_HELPCENTER_SELLER',
      actiontype: 'PAGE_SHOW'
    })
  },
  components: {
    QuestionCategorySeller
  }
}
</script>

<style lang="less" scoped>
  @import 'HelpCenter.less';
</style>
